/* eslint-disable no-console */
/**
 * カスタムロガーユーティリティ
 *
 * 開発環境ではすべてのログを出力し、本番環境では警告とエラーのみを出力します。
 *
 * 使用例:
 *   import logger from '@/utils/logger'
 *   logger.debug('デバッグ情報', data)
 *   logger.info('情報メッセージ')
 *   logger.warn('警告メッセージ')
 *   logger.error('エラーメッセージ', error)
 */

const isDevelopment = process.env.NODE_ENV === 'development'

export default {
  /**
   * デバッグレベルのログ（開発環境のみ）
   * @param {...any} args - ログに出力する引数
   */
  debug(...args) {
    if (isDevelopment) {
      console.debug(...args)
    }
  },

  /**
   * 情報レベルのログ（開発環境のみ）
   * @param {...any} args - ログに出力する引数
   */
  info(...args) {
    if (isDevelopment) {
      console.info(...args)
    }
  },

  /**
   * 警告レベルのログ（すべての環境）
   * @param {...any} args - ログに出力する引数
   */
  warn(...args) {
    console.warn(...args)
  },

  /**
   * エラーレベルのログ（すべての環境）
   * @param {...any} args - ログに出力する引数
   */
  error(...args) {
    console.error(...args)
  }
}
